import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import useProcessChecklist from '../../hooks/useProcessChecklist'

interface ChecklistScoreProps {
  processChecklistPayload: ReturnType<typeof useProcessChecklist>,
}

const ChecklistScore = (props: ChecklistScoreProps) => {
  const {
    processChecklistPayload: {
      calculatedScore: { availablePoints, receivedPoints },
    },
  } = props

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Score">
      <Box
        alignItems="center"
        flexDirection="column"
        padding="large"
      >
        <Text>
          {receivedPoints}/{availablePoints}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Points Received
        </Text>
      </Box>
    </DashboardModule>
  )
}

export default ChecklistScore
